import axios from "axios";
import { authHeader } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const createDeposit = () => axios.post(`${API}/deposits`, {}, { headers: authHeader() }).then((r) => r.data);
export const listDeposits = () => axios.get(`${API}/deposits`, { headers: authHeader() }).then((r) => r.data);
export const deleteDeposit = (id) => axios.delete(`${API}/deposits/${id}`, { headers: authHeader() }).then((r) => r.data);
export const downloadDeposit = async (id, filename) => {
  const res = await axios.get(`${API}/deposits/${id}/download`, { headers: authHeader(), responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "carnet.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
export const depositStatus = (token) => axios.get(`${API}/deposits/${token}/status`).then((r) => r.data);
export const viewDeposit = async (id) => {
  const res = await axios.get(`${API}/deposits/${id}/view`, { headers: authHeader(), responseType: "blob" });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  window.open(url, "_blank", "noopener,noreferrer");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
export const uploadDeposit = (token, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/deposits/${token}/upload`, fd).then((r) => r.data);
};
